module.exports = __webpack_public_path__ + "img/P150T_weapon_155.2e8ba1ef.png";